import React from "react";

const GoogleFormsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.81622 4L12.0099 4.41455L13.8162 4L9.81622 0L9.2644 1.89636L9.81622 4Z",
  fill: "#56368A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8163 4V0H3.27084C2.66811 0 2.17993 0.488182 2.17993 1.09091V14.9091C2.17993 15.5118 2.66811 16 3.27084 16H12.7254C13.3281 16 13.8163 15.5118 13.8163 14.9091V4H9.8163Z",
  fill: "#7248B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2708 11.5454C4.96989 11.5454 4.72534 11.3008 4.72534 10.9999C4.72534 10.699 4.96989 10.4545 5.2708 10.4545C5.57171 10.4545 5.81625 10.699 5.81625 10.9999C5.81625 11.3008 5.57171 11.5454 5.2708 11.5454ZM5.2708 9.36355C4.96989 9.36355 4.72534 9.119 4.72534 8.81809C4.72534 8.51718 4.96989 8.27264 5.2708 8.27264C5.57171 8.27264 5.81625 8.51718 5.81625 8.81809C5.81625 9.119 5.57171 9.36355 5.2708 9.36355ZM5.2708 7.18173C4.96989 7.18173 4.72534 6.93718 4.72534 6.63627C4.72534 6.33537 4.96989 6.09082 5.2708 6.09082C5.57171 6.09082 5.81625 6.33537 5.81625 6.63627C5.81625 6.93718 5.57171 7.18173 5.2708 7.18173ZM11.2708 11.4545H6.72534V10.5454H11.2708V11.4545ZM11.2708 9.27264H6.72534V8.36355H11.2708V9.27264ZM11.2708 7.09082H6.72534V6.18173H11.2708V7.09082Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleFormsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;